import produce from "immer";
import { policyCommonActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialPolicyCommonState } from "./policyCommon.types";
import {
  CLEAR_POLICY_COMMON_STATE,
  FETCH_POLICY_ARS_EXTRACT_LIST_FAILED,
  FETCH_POLICY_ARS_EXTRACT_LIST_PROGRESS,
  FETCH_POLICY_ARS_EXTRACT_LIST_SUCCESS,
  FETCH_POLICY_COMMON_CONTACTS_LIST_FAILED,
  FETCH_POLICY_COMMON_CONTACTS_LIST_PROGRESS,
  FETCH_POLICY_COMMON_CONTACTS_LIST_SUCCESS,
  FETCH_POLICY_COMMON_TELEMATICS_LIST_FAILED,
  FETCH_POLICY_COMMON_TELEMATICS_LIST_PROGRESS,
  FETCH_POLICY_COMMON_TELEMATICS_LIST_SUCCESS,
  FETCH_POLICY_OPCF48_FAILED,
  FETCH_POLICY_OPCF48_PROGRESS,
  FETCH_POLICY_OPCF48_SUCCESS,
  FETCH_POLICY_OPCF49_FAILED,
  FETCH_POLICY_OPCF49_PROGRESS,
  FETCH_POLICY_OPCF49_SUCCESS,
  FETCH_POLICY_SEF16_SUCCESS,
  FETCH_POLICY_SEF16_PROGRESS,
  FETCH_POLICY_SEF16_FAILED,
  FETCH_POLICY_SEF17_SUCCESS,
  FETCH_POLICY_SEF17_PROGRESS,
  FETCH_POLICY_SEF17_FAILED,
  FETCH_POLICY_SEF19_SUCCESS,
  FETCH_POLICY_SEF19_PROGRESS,
  FETCH_POLICY_SEF19_FAILED,
  FETCH_POLICY_SEF13D_SUCCESS,
  FETCH_POLICY_SEF13D_PROGRESS,
  FETCH_POLICY_SEF13D_FAILED,
  FETCH_POLICY_SEF13H_SUCCESS,
  FETCH_POLICY_SEF13H_PROGRESS,
  FETCH_POLICY_SEF13H_FAILED,
  FETCH_POLICY_SEF40_SUCCESS,
  FETCH_POLICY_SEF40_PROGRESS,
  FETCH_POLICY_SEF40_FAILED,
  FETCH_POLICY_AUTO_INSURANCE_PROGRESS,
  FETCH_POLICY_AUTO_INSURANCE_SUCCESS,
  FETCH_POLICY_AUTO_INSURANCE_FAILED,
  FETCH_POLICY_CANCELLATION_OR_REINSTATEMENT_PROGRESS,
  FETCH_POLICY_CANCELLATION_OR_REINSTATEMENT_SUCCESS,
  FETCH_POLICY_CANCELLATION_OR_REINSTATEMENT_FAILED,
  FETCH_POLICY_INTACT_AUTHORIZATION_PROGRESS,
  FETCH_POLICY_INTACT_AUTHORIZATION_SUCCESS,
  FETCH_POLICY_INTACT_AUTHORIZATION_FAILED,
  FETCH_POLICY_PREMIUM_FINANCE_LIST_PROGRESS,
  FETCH_POLICY_PREMIUM_FINANCE_LIST_SUCCESS,
  FETCH_POLICY_PREMIUM_FINANCE_LIST_FAILED,
  FETCH_POLICY_PREMIUM_FINANCE_PROGRESS,
  FETCH_POLICY_PREMIUM_FINANCE_SUCCESS,
  FETCH_POLICY_PREMIUM_FINANCE_FAILED,
  FETCH_POLICY_UPDATES_LIST_PROGRESS,
  FETCH_POLICY_UPDATES_LIST_SUCCESS,
  FETCH_POLICY_UPDATES_LIST_FAILED,
  FETCH_POLICY_LIABILITY_SLIP_PROGRESS,
  FETCH_POLICY_LIABILITY_SLIP_SUCCESS,
  FETCH_POLICY_LIABILITY_SLIP_FAILED,
  FETCH_POLICY_OPCF47R_PROGRESS,
  FETCH_POLICY_OPCF47R_SUCCESS,
  FETCH_POLICY_OPCF47R_FAILED,
} from "./policyCommonActions";
import { LoadState } from "../../constants/enums";

export const policyCommonReducer = (
  state: IStoreState["policyCommon"] = initialPolicyCommonState,
  action: policyCommonActions
) => {
  switch (action.type) {
    case FETCH_POLICY_COMMON_TELEMATICS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.telematics.loading = LoadState.InProgress;
        draftState.telematics.list = [];
        draftState.telematics.totalRecrods = 0;
      });
      return newState;
    }
    case FETCH_POLICY_COMMON_TELEMATICS_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.telematics.loading = LoadState.Loaded;
        draftState.telematics.list = list;
        draftState.telematics.totalRecrods = totalRecords;
      });
      return newState;
    }
    case FETCH_POLICY_COMMON_TELEMATICS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.telematics.loading = LoadState.InProgress;
        draftState.telematics.list = [];
        draftState.telematics.totalRecrods = 0;
      });
      return newState;
    }

    case FETCH_POLICY_COMMON_CONTACTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.contacts.loading = LoadState.InProgress;
        draftState.contacts.list = [];
      });
      return newState;
    }
    case FETCH_POLICY_COMMON_CONTACTS_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.contacts.loading = LoadState.Loaded;
        draftState.contacts.list = data;
      });
      return newState;
    }
    case FETCH_POLICY_COMMON_CONTACTS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.contacts.loading = LoadState.Failed;
        draftState.contacts.list = [];
      });
      return newState;
    }

    case FETCH_POLICY_ARS_EXTRACT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.abstracts.loading = LoadState.InProgress;
        draftState.abstracts.list = [];
      });
      return newState;
    }
    case FETCH_POLICY_ARS_EXTRACT_LIST_SUCCESS: {
      const { data } = action.payload;
      console.log("data", data);
      const newState = produce(state, (draftState) => {
        draftState.abstracts.loading = LoadState.Loaded;
        draftState.abstracts.list = data;
      });
      return newState;
    }
    case FETCH_POLICY_ARS_EXTRACT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.abstracts.loading = LoadState.Failed;
        draftState.abstracts.list = [];
      });
      return newState;
    }

    case FETCH_POLICY_OPCF47R_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.opcf47r.loading = LoadState.InProgress;
        draftState.opcf47r.data = initialPolicyCommonState["opcf47r"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_OPCF47R_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.opcf47r.loading = LoadState.Loaded;
        draftState.opcf47r.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_OPCF47R_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.opcf47r.loading = LoadState.Failed;
        draftState.opcf47r.data = initialPolicyCommonState["opcf47r"]["data"];
        draftState.opcf47r.error = errorMessage;
      });
      return newState;
    }

    case FETCH_POLICY_OPCF48_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.opcf48.loading = LoadState.InProgress;
        draftState.opcf48.data = initialPolicyCommonState["opcf48"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_OPCF48_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.opcf48.loading = LoadState.Loaded;
        draftState.opcf48.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_OPCF48_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.opcf48.loading = LoadState.Failed;
        draftState.opcf48.data = initialPolicyCommonState["opcf48"]["data"];
        draftState.opcf48.error = errorMessage;
      });
      return newState;
    }

    case FETCH_POLICY_OPCF49_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.opcf49.loading = LoadState.InProgress;
        draftState.opcf49.data = initialPolicyCommonState["opcf49"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_OPCF49_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.opcf49.loading = LoadState.Loaded;
        draftState.opcf49.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_OPCF49_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.opcf49.loading = LoadState.Failed;
        draftState.opcf49.data = initialPolicyCommonState["opcf49"]["data"];
        draftState.opcf49.error = errorMessage;
      });
      return newState;
    }
    case FETCH_POLICY_SEF16_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sef16.loading = LoadState.InProgress;
        draftState.sef16.data = initialPolicyCommonState["sef16"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_SEF16_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef16.loading = LoadState.Loaded;
        draftState.sef16.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_SEF16_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef16.loading = LoadState.Failed;
        draftState.sef16.data = initialPolicyCommonState["sef16"]["data"];
        draftState.sef16.error = errorMessage;
      });
      return newState;
    }
    case FETCH_POLICY_SEF17_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sef17.loading = LoadState.InProgress;
        draftState.sef17.data = initialPolicyCommonState["sef17"]["data"];
      });
      return newState;
    }

    case FETCH_POLICY_SEF17_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef17.loading = LoadState.Loaded;
        draftState.sef17.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_SEF17_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef17.loading = LoadState.Failed;
        draftState.sef17.data = initialPolicyCommonState["sef17"]["data"];
        draftState.sef17.error = errorMessage;
      });
      return newState;
    }
    case FETCH_POLICY_SEF19_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sef19.loading = LoadState.InProgress;
        draftState.sef19.data = initialPolicyCommonState["sef19"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_SEF19_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef19.loading = LoadState.Loaded;
        draftState.sef19.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_SEF19_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef19.loading = LoadState.Failed;
        draftState.sef19.data = initialPolicyCommonState["sef19"]["data"];
        draftState.sef19.error = errorMessage;
      });
      return newState;
    }

    case FETCH_POLICY_SEF13D_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sef13d.loading = LoadState.InProgress;
        draftState.sef13d.data = initialPolicyCommonState["sef13d"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_SEF13D_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef13d.loading = LoadState.Loaded;
        draftState.sef13d.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_SEF13D_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef13d.loading = LoadState.Failed;
        draftState.sef13d.data = initialPolicyCommonState["sef13d"]["data"];
        draftState.sef13d.error = errorMessage;
      });
      return newState;
    }
    case FETCH_POLICY_SEF13H_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sef13h.loading = LoadState.InProgress;
        draftState.sef13h.data = initialPolicyCommonState["sef13h"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_SEF13H_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef13h.loading = LoadState.Loaded;
        draftState.sef13h.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_SEF13H_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef13h.loading = LoadState.Failed;
        draftState.sef13h.data = initialPolicyCommonState["sef13h"]["data"];
        draftState.sef13h.error = errorMessage;
      });
      return newState;
    }
    case FETCH_POLICY_SEF40_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sef40.loading = LoadState.InProgress;
        draftState.sef40.data = initialPolicyCommonState["sef40"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_SEF40_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef40.loading = LoadState.Loaded;
        draftState.sef40.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_SEF40_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sef40.loading = LoadState.Failed;
        draftState.sef40.data = initialPolicyCommonState["sef40"]["data"];
        draftState.sef40.error = errorMessage;
      });
      return newState;
    }
    case FETCH_POLICY_AUTO_INSURANCE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.automobile_insurance.loading = LoadState.InProgress;
        draftState.automobile_insurance.data =
          initialPolicyCommonState["automobile_insurance"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_AUTO_INSURANCE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.automobile_insurance.loading = LoadState.Loaded;
        draftState.automobile_insurance.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_AUTO_INSURANCE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.automobile_insurance.loading = LoadState.Failed;
        draftState.automobile_insurance.data =
          initialPolicyCommonState["automobile_insurance"]["data"];
        draftState.automobile_insurance.error = errorMessage;
      });
      return newState;
    }
    case FETCH_POLICY_CANCELLATION_OR_REINSTATEMENT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.cancellation_reinstatement.loading = LoadState.InProgress;
        draftState.cancellation_reinstatement.data =
          initialPolicyCommonState["cancellation_reinstatement"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_CANCELLATION_OR_REINSTATEMENT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.cancellation_reinstatement.loading = LoadState.Loaded;
        draftState.cancellation_reinstatement.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_CANCELLATION_OR_REINSTATEMENT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.cancellation_reinstatement.loading = LoadState.Failed;
        draftState.cancellation_reinstatement.data =
          initialPolicyCommonState["cancellation_reinstatement"]["data"];
        draftState.cancellation_reinstatement.error = errorMessage;
      });
      return newState;
    }
    case FETCH_POLICY_INTACT_AUTHORIZATION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.intact_authorization.loading = LoadState.InProgress;
        draftState.intact_authorization.data =
          initialPolicyCommonState["intact_authorization"]["data"];
      });
      return newState;
    }
    case FETCH_POLICY_INTACT_AUTHORIZATION_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.intact_authorization.loading = LoadState.Loaded;
        draftState.intact_authorization.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_INTACT_AUTHORIZATION_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.intact_authorization.loading = LoadState.Failed;
        draftState.intact_authorization.data =
          initialPolicyCommonState["intact_authorization"]["data"];
        draftState.intact_authorization.error = errorMessage;
      });
      return newState;
    }

    case FETCH_POLICY_PREMIUM_FINANCE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.premiumFinance.loading = LoadState.InProgress;
        draftState.premiumFinance.data = [];
      });
      return newState;
    }
    case FETCH_POLICY_PREMIUM_FINANCE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.premiumFinance.loading = LoadState.Loaded;
        draftState.premiumFinance.data = data;
        draftState.premiumFinance.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_POLICY_PREMIUM_FINANCE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.premiumFinance.loading = LoadState.Failed;
        draftState.premiumFinance.data = [];
      });
      return newState;
    }

    case FETCH_POLICY_PREMIUM_FINANCE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.premiumFinance.premiumFALoading = LoadState.InProgress;
        draftState.premiumFinance.premiumFA =
          initialPolicyCommonState["premiumFinance"]["premiumFA"];
      });
      return newState;
    }
    case FETCH_POLICY_PREMIUM_FINANCE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.premiumFinance.premiumFALoading = LoadState.Loaded;
        draftState.premiumFinance.premiumFA = data;
      });
      return newState;
    }
    case FETCH_POLICY_PREMIUM_FINANCE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.premiumFinance.premiumFALoading = LoadState.Failed;
        draftState.premiumFinance.error = errorMessage;
      });
      return newState;
    }

    case FETCH_POLICY_UPDATES_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.policyUpdates.loading = LoadState.InProgress;
        draftState.policyUpdates.list = [];
      });
      return newState;
    }

    case FETCH_POLICY_UPDATES_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.policyUpdates.loading = LoadState.Loaded;
        draftState.policyUpdates.list = list;
      });
      return newState;
    }

    case FETCH_POLICY_UPDATES_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.policyUpdates.loading = LoadState.Failed;
        draftState.policyUpdates.list = [];
      });
      return newState;
    }

    case FETCH_POLICY_LIABILITY_SLIP_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.liabilitySlips.dataLoading = LoadState.InProgress;
        draftState.liabilitySlips.data =
          initialPolicyCommonState.liabilitySlips.data;
      });
      return newState;
    }
    case FETCH_POLICY_LIABILITY_SLIP_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.liabilitySlips.dataLoading = LoadState.Loaded;
        draftState.liabilitySlips.data = data;
      });
      return newState;
    }
    case FETCH_POLICY_LIABILITY_SLIP_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.liabilitySlips.dataLoading = LoadState.Failed;
        draftState.liabilitySlips.data =
          initialPolicyCommonState.liabilitySlips.data;
        draftState.liabilitySlips.error = errorMessage;
      });
      return newState;
    }

    case CLEAR_POLICY_COMMON_STATE: {
      return initialPolicyCommonState;
    }

    default: {
      return state;
    }
  }
};
